{
  "refinement.life.window.move": "Move window · Alt + arrow keys",
  "refinement.life.window.minimize": "Minimize window",
  "refinement.life.window.restoreSize": "Restore window size",
  "refinement.life.window.maximize": "Maximize window",
  "refinement.life.window.close": "Close window",
  "refinement.life.window.resize": "Resize window · arrow keys",
  "refinement.life.window.linkError": "This Life area or table could not be opened. Please try the link again.",
  "refinement.life.window.dismiss": "Dismiss",
  "refinement.life.window.loading": "Life area",
  "refinement.life.window.tableUnavailable": "This table is no longer available in this area. Choose another table or Overview.",
  "refinement.life.calendar.label": "Life tracking calendar",
  "refinement.life.calendar.moments_one": "entry",
  "refinement.life.calendar.moments_other": "entries",
  "refinement.life.calendar.records_one": "record",
  "refinement.life.calendar.records_other": "records",
  "refinement.life.calendar.previous": "Previous month",
  "refinement.life.calendar.next": "Next month",
  "refinement.life.calendar.month": "Choose month",
  "refinement.life.calendar.today": "Today",
  "refinement.life.calendar.monthView": "Month",
  "refinement.life.calendar.listView": "List",
  "refinement.life.calendar.filters": "Filters",
  "refinement.life.calendar.hint": "Select a day to see its full contents. Blank days have no records matching your filters.",
  "refinement.life.calendar.openDay_one": "Open {{date}} · {{count}} entry or record",
  "refinement.life.calendar.openDay_other": "Open {{date}} · {{count}} entries and records"
}
